import { render, staticRenderFns } from "./indexPageNew.vue?vue&type=template&id=be56ff96&scoped=true"
import script from "./indexPageNew.vue?vue&type=script&lang=js"
export * from "./indexPageNew.vue?vue&type=script&lang=js"
import style0 from "./indexPageNew.vue?vue&type=style&index=0&id=be56ff96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be56ff96",
  null
  
)

export default component.exports